import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setItems([]); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/cart");
      setItems(data.items || []);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (productId, quantity = 1) => {
    await api.post("/cart/add", { product_id: productId, quantity });
    await refresh();
  };
  const remove = async (productId) => {
    await api.post("/cart/remove", { product_id: productId, quantity: 0 });
    await refresh();
  };
  const clear = async () => { await api.post("/cart/clear"); await refresh(); };

  const count = items.reduce((s, it) => s + (it.quantity || 0), 0);
  const total = items.reduce((s, it) => s + (it.quantity * (it.product?.price || 0)), 0);

  return (
    <CartCtx.Provider value={{ items, count, total, loading, add, remove, clear, refresh }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
